import React from 'react';
import './ProjectGrid.css';

import ProjectThumb from './ProjectThumb';

const ProjectGrid = ({ projects, onProjectClick }) => (
    <div className="project-grid">
        {projects?.map((project) => (
            <ProjectThumb key={project.id} project={project} onClick={() => onProjectClick(project)} />
        ))}
    </div>
);

export default ProjectGrid;
